// extracted by mini-css-extract-plugin
export var mainBtn = "main-module--main-btn--ec277";
export var methodists = "main-module--methodists--48bc2";
export var methodists__bottomText = "main-module--methodists__bottom-text--3e4db";
export var sec = "main-module--sec--0b912";
export var title2 = "main-module--title2--898c6";
export var videoReviews__bottom = "main-module--video-reviews__bottom--87ca9";